module.exports = __webpack_public_path__ + "img/nav.e28f52af.png";